import { createFileRoute } from "@tanstack/react-router";
import LandingPage from "#/features/landing/landing_layout.tsx";

export const Route = createFileRoute("/ko/")({
	component: LandingPage,
});
